<script lang="ts" setup>
import {
  tpgIconAdd,
  tpgIconClose,
  tpgIconLayersFull,
  tpgIconMap,
} from '@tpg/grammar-web-icons';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  GrammarDivider,
  GrammarNavigationRailItem,
  GrammarPrimaryButton,
} from '@nora-monorepo/grammar-ui';
import { useDarkModeStore } from '@nora-monorepo/ui-shared';

import { useMapStore } from '#nora-ui/map/stores/map-store';

interface Props {
  mapId: string;
}

const props = defineProps<Props>();

const { t } = useI18n();
const mapStore = useMapStore();
const darkModeStore = useDarkModeStore();

const map = mapStore.getMapByIdOrThrow(props.mapId);

// Icon color follows the app theme so icons stay legible on the (themed) rail.
const iconColor = computed(() => (darkModeStore.isDark ? '#AABECB' : '#677079'));

function toggleLayersMenu() {
  map.state.draw.toggleDrawLayerMenuOpen();
}

function openNewMap() {
  mapStore.addMap();
}

function removeMap() {
  if (props.mapId) {
    mapStore.removeMap(props.mapId);
  }
}
</script>

<template>
  <div class="flex flex-row w-full h-12 bg-light-bg-secondary dark:bg-dark-bg-secondary">
    <div class="flex flex-row ml-auto items-center pl-5">
      <div class="my-1">
        <GrammarDivider
          type="button"
          orientation="vertical"
        />
      </div>
      <div class="pt-1 pb-1 pr-2 max-w-75">
        <GrammarPrimaryButton
          size="small"
          :label="map.state.draw.operationLayerLabel.value"
          :icon-template="tpgIconLayersFull"
          @click="toggleLayersMenu"
        />
      </div>
      <div class="pt-1 pb-1 pr-2">
        <GrammarPrimaryButton
          size="small"
          :label="t('mapLayers.baseMap')"
          :icon-template="tpgIconMap"
          @click="map.toggleSidePanel('base-map')"
        />
      </div>
      <GrammarNavigationRailItem
        :icon-template="tpgIconAdd"
        :icon-color="iconColor"
        title="Add map"
        @click="openNewMap"
      />

      <div class="my-1">
        <GrammarDivider
          type="button"
          orientation="vertical"
        />
      </div>

      <GrammarNavigationRailItem
        v-if="mapStore.mapCount > 1"
        :icon-template="tpgIconClose"
        :icon-color="iconColor"
        title="Close"
        @click="removeMap"
      />
    </div>
  </div>
</template>
